import * as types from '../constants/ActionTypes';

export const selectTopDepartment = d => ({type: types.SELECT_TOP_DEPARTMENT, id: d.value})
export const selectChildDepartment = d => ({type: types.SELECT_CHILD_DEPARTMENT, id: d.value})

export const loggedInUser = (user) => {
    return {
        type: types.LOGGED_IN_USER,
        user
    }
}

// export const purchaseVipUser = (user) => {
//     return {
//         type: types.PURCHASE_VIP,
//         user
//     }
// }

// export const purchasePackageUser = (user) => {
//     return {
//         type: types.PURCHASE_PACKAGE,
//         user
//     }
// }

// export const purchaseDayUser = (user) => {
//     return {
//         type: types.PURCHASE_DAY,
//         user
//     }
// }

// export const purchaseMediaUser = (user) => {
//     return {
//         type: types.PURCHASE_MEDIA,
//         user
//     }
// }



// WEBPACK FOOTER //
// ./src/actions/user.js